import { Box, IconButton } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IconClose } from "src/components/icons";
import { AnimatedHeading } from "src/components/pages/search/components/animated-heading";

interface ISearchFilterHeaderProps {
    handleOnClear: () => void;
    isMobile?: boolean;
    searchTerm?: string | string[];
}

const mobileIconStyles = {
    marginTop: "-0.5",
    marginRight: "-1",
};

export const SearchFilterHeader = ({ searchTerm, isMobile, handleOnClear }: ISearchFilterHeaderProps) => {
    const { t } = useTranslation(["extended-search", "common"]);
    const iconButtonStyles = isMobile ? mobileIconStyles : null;
    return (
        <Box display="flex" justifyContent={isMobile ? "space-between" : "initial"} alignItems={isMobile ? "initial" : "baseline"}>
            <AnimatedHeading searchTerm={searchTerm} headline={t("headlines.find-wikifolios")} isMobile={isMobile} />
            {searchTerm && (
                <IconButton
                    aria-label={t("clear", { ns: "common" })}
                    onClick={handleOnClear}
                    variant="ghost"
                    rounded="50%"
                    boxSize={5}
                    minW={5}
                    ml={1}
                    icon={<IconClose boxSize={3} />}
                    {...iconButtonStyles}
                />
            )}
        </Box>
    );
};
